export default __webpack_public_path__ + "static/media/stats-down.99fae428.svg";